import { useEffect, useState } from "react";
import { Sun, Moon, Monitor } from "lucide-react";
import { cn } from "@/cn";
import {
  cycleTheme,
  getCurrentTheme,
  onThemeChange,
  type ThemeMode,
} from "@/lib/theme";

const LABELS: Record<ThemeMode, string> = {
  light: "Light",
  dark: "Dark",
  system: "System",
};

const NEXT: Record<ThemeMode, ThemeMode> = {
  light: "dark",
  dark: "system",
  system: "light",
};

export function ThemeToggle({ className }: { className?: string }) {
  const [mode, setMode] = useState<ThemeMode>("system");

  useEffect(() => {
    setMode(getCurrentTheme());
    return onThemeChange(() => setMode(getCurrentTheme()));
  }, []);

  const next = NEXT[mode];

  return (
    <button
      type="button"
      onClick={() => cycleTheme()}
      aria-label={`Theme: ${LABELS[mode]}. Switch to ${LABELS[next]}`}
      title={`${LABELS[mode]} theme`}
      className={cn(
        "inline-flex items-center justify-center rounded-md p-1.5 text-muted transition-colors hover:bg-surface-hover hover:text-foreground max-sm:min-h-[44px] max-sm:min-w-[44px]",
        className,
      )}
    >
      {mode === "light" ? (
        <Sun className="size-4" />
      ) : mode === "dark" ? (
        <Moon className="size-4" />
      ) : (
        <Monitor className="size-4" />
      )}
    </button>
  );
}
